import { Switch, Route } from 'react-router-dom';

import AuthUser from './AuthUser';
import { JSX } from 'react';

const Routes = (): JSX.Element => (
  <Switch>
    <Route exact path="/auth-user">
      <AuthUser />
    </Route>
  </Switch>
);

export default Routes;
